import {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';

export const PASSWORD_MIN_LENGTH = 8;

export const passwordValidators = [
  Validators.required,
  Validators.minLength(PASSWORD_MIN_LENGTH),
];

/** Edit: password may stay empty; if filled, at least 8 characters. */
export const optionalPasswordValidators = [
  Validators.minLength(PASSWORD_MIN_LENGTH),
];

export function matchPasswords(
  passwordKey: string,
  confirmPasswordKey: string,
): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    const password = formGroup.get(passwordKey)?.value;
    const confirmPassword = formGroup.get(confirmPasswordKey)?.value;

    if (password !== confirmPassword) {
      formGroup.get(confirmPasswordKey)?.setErrors({ passwordMismatch: true });
      return { passwordMismatch: true };
    } else {
      const errors = formGroup.get(confirmPasswordKey)?.errors;
      if (errors) {
        delete errors['passwordMismatch'];
        if (Object.keys(errors).length === 0) {
          formGroup.get(confirmPasswordKey)?.setErrors(null);
        }
      }
      return null;
    }
  };
}
